/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { SortDirection, SortDirectionFromJSON, SortDirectionToJSON } from './SortDirection'

/**
 *
 * @export
 * @interface CustomersSort
 */
export interface CustomersSort {
  /**
   * The field on which to sort the Customers
   * @type {string}
   * @memberof CustomersSort
   */
  by?: CustomersSortBy
  /**
   *
   * @type {SortDirection}
   * @memberof CustomersSort
   */
  direction?: SortDirection
}

/**
 * @export
 * @enum {string}
 */
export enum CustomersSortBy {
  created_at = 'created_at',
  updated_at = 'updated_at'
}

export function CustomersSortFromJSON(json: any): CustomersSort {
  return CustomersSortFromJSONTyped(json, false)
}

export function CustomersSortFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomersSort {
  if (json === undefined || json === null) {
    return json
  }
  return {
    by: !exists(json, 'by') ? undefined : json['by'],
    direction: !exists(json, 'direction') ? undefined : SortDirectionFromJSON(json['direction'])
  }
}

export function CustomersSortToJSON(value?: CustomersSort | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    by: value.by,
    direction: SortDirectionToJSON(value.direction)
  }
}
